import { render, staticRenderFns } from "./creation-site-internet.vue?vue&type=template&id=f4bd4010&"
import script from "./creation-site-internet.vue?vue&type=script&lang=js&"
export * from "./creation-site-internet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./creation-site-internet.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/app/components/Header.vue').default,Button: require('/app/components/Button.vue').default,NuxtSource: require('/app/components/NuxtSource.vue').default,Scroll: require('/app/components/Scroll.vue').default,Arguments: require('/app/components/Arguments.vue').default,Arguments2: require('/app/components/Arguments2.vue').default,Price: require('/app/components/Price.vue').default,ListCheckRed: require('/app/components/ListCheckRed.vue').default,TalkWithExpert: require('/app/components/TalkWithExpert.vue').default,LittleFaq: require('/app/components/LittleFaq.vue').default,FooterV2: require('/app/components/FooterV2.vue').default,LazyCalendly: require('/app/components/LazyCalendly.vue').default})
